import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const CreateOrgPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/CreateOrgPageContainer" */
      './CreateOrgPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
